import { BasePlayer } from "@repo/shared/types";

import axios from "../../api";

export type PopularSquad = {
  id: string;
  // rank/division/established are the backend's en-US strings, used when the raw fields are absent.
  rank: string;
  rankNumber?: number;
  division: string;
  rivalsDivision?: number;
  username: string | null;
  established: string;
  /** ISO date, null when the club has none. */
  establishedAt?: string | null;
  avatar: string;
  teamMetaRating: number;
  teamChemistry: number;
  formation: string;
  firstOwners: number;
  tradeables: number;
  evolutions: number;
  topPlayers: BasePlayer[];
};

export const getLeaderboardSquads = async ({
  random,
}: {
  random: boolean;
}): Promise<PopularSquad[]> => {
  const response = await axios.get<PopularSquad[]>(
    `/leaderboard/squads${random ? "?featured=random" : "?featured"}`,
  );
  return response.data;
};

export const getOwnSquad = async (): Promise<PopularSquad> => {
  const response = await axios.get<PopularSquad>("/leaderboard/squads/me");
  return response.data;
};
